<template>
  <o-dialog
    ref="dialog"
    :title="$t('auth.password.resetPassword.title2')"
    :info="$t('auth.password.resetPassword.for', { name: customer.displayName })"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('auth.password.resetPassword.title'), type: 'confirm', callback: confirm },
    ]"
    :portal="portal"
    :valid="validate"
  >
    <div class="mt-4 text-left ">
      <o-form ref="form">
        <o-field-group v-slot="{ status }" :label="$t('auth.password.new')" name="NewPassword" rules="required|password:@Confirm" class="block pb-3">
          <password-field v-model="newPassword" :status="status" />
        </o-field-group>

        <o-field-group v-slot="{ status }" :label="$t('auth.password.confirm')" name="Confirm" rules="required" class="block pb-3">
          <password-field v-model="confirmPassword" :status="status" />
        </o-field-group>

        <div class="flex justify-end mb-4">
          <o-button size="sm" @click="generate">
            {{ $t('auth.password.suggest') }}
          </o-button>
        </div>

        <o-field-group>
          <checkbox-field v-model="sendEmail" :label="$t('general.sendEmail')" :info="$t('auth.password.resetPassword.notifyCustomer')" label-class="text-sm ml-3 text-gray-800" />
        </o-field-group>
      </o-form>
    </div>
  </o-dialog>
</template>

<script setup lang="ts">
import {
  PasswordField,
  CheckboxField,
} from '@/components/fields'

interface Props {
  customer: any
  portal?: string
  loading?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const { $api, $i18n, $notification } = useNuxtApp()

const dialog = ref<any>()
const form = ref<any>()
const sendEmail = ref(false)
const newPassword = ref('')
const confirmPassword = ref('')

const open = () => {
  sendEmail.value = false
  newPassword.value = ''
  confirmPassword.value = ''

  dialog.value.open()
}

const confirm = async () => {
  try {
    const response = await $api.customer.resetPassword(
      props.customer.idCustomer.toString(),
      {
        password: newPassword.value,
        confirm: confirmPassword.value,
        sendEmail: sendEmail.value,
      },
    )

    if (response.success) {
      $notification.toast({
        title: $i18n.t('auth.password.changeSuccess'),
        text: $i18n.t('auth.password.resetPassword.successInfo', { name: props.customer.displayName }),
        variant: 'success',
      })

      return response.success
    }
  } catch (e: any) {
    $notification.toast({
      title: $i18n.t('auth.password.resetPassword.error'),
      text: $i18n.t('auth.password.resetPassword.errorInfo', { name: props.customer.displayName }),
      variant: 'danger',
    })

    console.log(e)
  }
}

const validate = () => {
  return form.value?.validate()
}

const generate = () => {
  const suggested = Array(10)
    .fill('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz~!@-#$')
    .map(x => x[Math.floor(crypto.getRandomValues(new Uint32Array(1))[0] / (0xFFFFFFFF + 1) * x.length)])
    .join('')

  newPassword.value = suggested
  confirmPassword.value = suggested
}

defineExpose({ open })
</script>
